export const LOCAL_CONSTANT = {
    FUNCTION_NAME:{
        APP_DISPLAY: "メインメニュー画面 表示",
        IMPACT_MAP_DISPLAY: "影響度 マップ画面 表示",
        IMPACT_MAP_LATLNG_DISPLAY: "影響度 マップ画面 緯度経度指定表示",
        IMPACT_COUNTER_DISPLAY: "影響度 カウンター 表示",
        IMPACT_SAVE: "影響度 保存",
        TRAFFIC_VOLUME_INDEX_DISPLAY: "通行量 インデックス画面 表示",
        TRAFFIC_VOLUME_DISPLAY: "通行量 測定設定画面 表示",
        TRAFFIC_VOLUME_REGIST_DISPLAY: "通行量 登録画面 表示",
        TRAFFIC_CONFIRMATION_DISPLAY: "通行量 確認画面 表示",
        TRAFFIC_VOLUME_SAVE: "通行量 保存",
        PHOTO_UPLOAD_INDEX_DISPLAY: "写真アップロード インデックス画面 表示",
        PHOTO_UPLOAD_DISPLAY: "写真アップロード画面 表示",
        TRAFFIC_COUNTER_DISPLAY: "TrafficCounter画面 表示",
        PLANAREAMENU_DISPLAY: "候補地メニュー画面 表示",
        STOREMENU_DISPLAY: "既存店メニュー画面 表示",
    },
    ERROR_MESSAGE: {
        PLAN_AREA_ID_NOT_FOUND: "調査書Noが取得できない為、調査出来ません。\nブラウザの全てのタブを閉じて再操作してください。"
    }
};
